/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { OrderCustomerDtoCreate } from '../../models/order-customer-dto-create';
import { OrderCustomerItem } from '../../models/order-customer-item';

export interface OrderCustomerControllerCreate$Params {
      body: OrderCustomerDtoCreate
}

export function orderCustomerControllerCreate(http: HttpClient, rootUrl: string, params: OrderCustomerControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: OrderCustomerItem;
}>> {
  const rb = new RequestBuilder(rootUrl, orderCustomerControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: OrderCustomerItem;
      }>;
    })
  );
}

orderCustomerControllerCreate.PATH = '/order-customer';
